import server from '../request/encryptRequest';

export const queryCount = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubConfig/count', data);
};

export const itemList = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubConfig/itemList', data);
};

export const pageList = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubConfig/pageList', data);
};

export const saveItem = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubConfig/saveItem', data);
};

export const updateStatus = (data) => {
  return server.post('/xiaozi-saas/wireless/bizOppSubConfig/updateStatus', data);
};
